import PageBanner from '../components/ui/PageBanner';
import doctors from '../data/doctors.import.json';
import './DoctorDetails.css';

export default function DoctorDetails({ route, setPage }) {
  const rawId = route?.params?.doctorId;
  const doctorId = typeof rawId === 'string' ? Number(rawId) : rawId;

  const doctor = doctors.find(d => d.id === doctorId);

  if (!doctor) {
    return (
      <>
        <PageBanner title="Doctor Details" crumbs={['Home', 'Our Doctors', 'Doctor Details']} />
        <section className="section">
          <div className="section-inner">
            <div className="doc-details card">
              <h3 className="doc-details__title">Doctor not found</h3>
              <p className="doc-details__muted">The doctor you’re looking for doesn’t exist (ID: {String(rawId)}).</p>
              <button type="button" className="btn-outline doc-details__back" onClick={() => setPage?.('packages')}>
                Back to Doctors
              </button>
            </div>
          </div>
        </section>
      </>
    );
  }

  return (
    <>
      <PageBanner title="Doctor Details" crumbs={['Home', 'Our Doctors', doctor.name]} />
      <section className="section">
        <div className="section-inner">
          <div className="doc-details card">
            <div className="doc-details__top">
              <button type="button" className="btn-outline doc-details__back" onClick={() => setPage?.('packages')}>
                Back to Doctors
              </button>
            </div>

            <div className="doc-details__head">
              <div className="doc-details__avatar">
                {doctor.photo ? (
                  <img className="doc-details__avatar-img" src={doctor.photo} alt={doctor.name} loading="lazy" />
                ) : (
                  '👨‍⚕️'
                )}
              </div>
              <div>
                <h3 className="doc-details__name">{doctor.name}</h3>
                <p className="doc-details__spec">{doctor.spec || '—'}</p>
                <p className="doc-details__branch">{doctor.branch || '—'}</p>
              </div>
            </div>

            <div className="doc-details__grid">
              <div className="doc-details__item">
                <strong>OPD Days</strong>
                <span>{doctor.opdDays || '—'}</span>
              </div>
              <div className="doc-details__item">
                <strong>Time</strong>
                <span>{doctor.time || '—'}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
